// Decides whether the fixed-bottom convention pay bar should render,
// and which action it represents. Pure function — no stores, no JSX.
//
// Returns:
//   { visible: false }
// or:
//   {
//       visible: true,
//       action: 'paySignup' | 'payNextStart' | 'goToCart' | 'payNewSignup',
//       variant: 'btn-warning' | 'btn-info',
//       remaining: number,  // only when action === 'payNextStart' — unpaid stages left
//       cartCount: number,  // only when action === 'goToCart' — items in the basket
//   }
//
// Precedence: money owed on the signup fee first (paySignup / payNextStart),
// then the basket (goToCart) whenever it holds items, then the competition
// "extra signup" upsell. The basket button follows the Produkter tab, which
// only needs the user to be signed up — no signup fee or open registration.

// How many starts a shooter owes the signup fee for, given the number of Lag
// they are on. Competitions (isCompetition) charge per start — one fee per Lag.
// Trainings charge the signup fee ONCE no matter how many Lag the shooter joins
// (see the isCompetition field help: "enables extra-start payment").
export function requiredStarts(convention, lagCount) {
    const count = Number(lagCount) > 0 ? Number(lagCount) : 0;
    if (convention?.isCompetition) return count;
    return Math.min(count, 1);
}

export function getConventionPayState({
    convention,
    userId,
    signedUp,
    isInTheFuture,
    isRegistrationOpen,
    cartCount = 0,
}) {
    if (!userId) return { visible: false };
    if (!convention) return { visible: false };
    if (!signedUp) return { visible: false };

    const hasOpenSignupFee = convention.signupProduct > 0
        && (isInTheFuture || isRegistrationOpen);

    if (hasOpenSignupFee) {
        const participants = convention.participants || [];
        const currentParticipant = participants.find(p => p.id === userId);
        const paidStartsCount = currentParticipant?.paidStartsCount || 0;

        let lagCount = 0;
        const stages = convention.stages || [];
        stages.forEach((stage, idx) => {
            const stageParticipants = convention[`participants${idx + 1}`] || [];
            if (stageParticipants.find(p => p.id === userId)) {
                lagCount += 1;
            }
        });

        if (paidStartsCount === 0) {
            return { visible: true, action: 'paySignup', variant: 'btn-warning' };
        }

        const required = requiredStarts(convention, lagCount);
        if (paidStartsCount < required) {
            return {
                visible: true,
                action: 'payNextStart',
                variant: 'btn-warning',
                remaining: required - paidStartsCount,
            };
        }
    }

    if (Number(cartCount) > 0) {
        return {
            visible: true,
            action: 'goToCart',
            variant: 'btn-warning',
            cartCount: Number(cartCount),
        };
    }

    if (hasOpenSignupFee && convention.isCompetition) {
        return { visible: true, action: 'payNewSignup', variant: 'btn-info' };
    }

    return { visible: false };
}
